import BaseComponent from "../../base/base_component";
import DOM from "../../utils/dom";
import Device from "../../utils/device/device";
import {SYSTEM_EVENTS} from "../../events/events";

let sessionTimerView = require('./view/session_timer.html');

export default class SessionTimerController extends BaseComponent {


    /**
     *
     * @type {string}
     */
    static CLASS = 'SessionTimerController';


    /**
     *
     * @type {string}
     */
    static DIRECTIVE = 'cgp-directive-session_timer';


    /**
     *
     * @type {string}
     * @private
     */
    protected _selector = 'session-timer-component';


    /**
     * Refference to the html nodes that display the session time and the component container
     *  {
			default: htmlElement,
			navbar: htmlElement,
			container: htmlElement
		}
     * @type {Object | null}
     * @private
     */
    _htmlElementsReff = null;


    /**
     * {
     * 	timeoffset: number | undefined | null
     * 	}
     * @param params
     */
    init(params) {
        super.init(params);
    }


    /**
     *
     * @returns {SessionTimerController}
     */
    start() {
        this.setHTML(this.bake(sessionTimerView));
        this._htmlElementsReff = {
            default: this.querySelector('#session-timer'),
            navbar: this.querySelector('#session-timer-navbar'),
            container: this.querySelector('#container'),
            mobileLarge: this.querySelector('#session-timer-mobile-large')
        };

        DOM.addStyle(this._htmlElementsReff.container, 'display', 'none');
        this._subscribe();

        if (this.serviceFactory.oAuth2Service().isAuthorized()) {
            this._onLogin();
        }

        return this;
    }


    /**
     * Subscribes to the oauth state change event to show / hide (and stop) the session time
     * @private
     */
    _subscribe() {
        this.onSystemEvent(SYSTEM_EVENTS.OAUTH_STATE_CHANGE, () => {
            if (this.serviceFactory.oAuth2Service().isAuthorized()) {
                this._onLogin();
            } else {
                DOM.addStyle(this._htmlElementsReff.container, 'display', 'none');
            }
        });
    }


    _onLogin() {
        this._updateTime({
            sessionTime: this.serviceFactory.regulationService().getRegulation().getCurrentSessionTime()
        });

        if (this.serviceFactory.regulationService().sessionTimerVisible()) {
            DOM.removeStyle(this._htmlElementsReff.container, 'display');
        }
        this.onSystemEvent(SYSTEM_EVENTS.SESSION_TIMER_UPDATE, this._updateTime);
    }


    /**
     * Updates the time fields in the view
     * @private
     */
    _updateTime(params: any = {}) {
        let elapsedTime = params.sessionTime;
        let timeString = '00 : 00';

        if (elapsedTime) {
            timeString = String(elapsedTime.days * 24 + elapsedTime.hours).padStart(2, '0') + ' : ' + elapsedTime.minutes.toString().padStart(2, '0');
        }

        if(this._htmlElementsReff.default.innerText !== timeString) {
            DOM.html(timeString, this._htmlElementsReff.default);
        }

        if(this._htmlElementsReff.navbar.innerText !== timeString) {
            DOM.html(timeString, this._htmlElementsReff.navbar);
        }


        if (Device.isMobile()) {
            if(this._htmlElementsReff.mobileLarge.innerText !== timeString) {
                DOM.html(timeString, this._htmlElementsReff.mobileLarge);
            }
        }
    }
}